import type { ISbStoryData } from '@storyblok/js';
import type { LegalPageStoryblok } from '$types/bloks';
import type { DynamicPage } from '$pages/dynamic-page.svelte';

type LegalPageStory = ISbStoryData<LegalPageStoryblok>;

export type LegalPage = {
  story: LegalPageStory;
};

export const isLegalPageStory = (story: DynamicPage['story']): story is LegalPageStory => {
  return story.content.component === 'legal-page';
};
export const isLegalPage = (data: DynamicPage): data is LegalPage => {
  return data.story.content.component === 'legal-page';
};

export const LEGAL_PAGE_RELATIONS = [] as const;

export const getLegalPageData = async ({
  story
}: {
  story: LegalPageStory;
}): Promise<LegalPage> => {
  return {
    story
  };
};
